module.exports = __webpack_public_path__ + "static/img/75a1.feddf63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a1.jpg
// module id = npBN
// module chunks = 1